export default [
  { label: 'ui-erm-usage.general.status.active', value: 'active' },
  { label: 'ui-erm-usage.general.status.inactive', value: 'inactive' }
];
